const steps = [
  "Personal Information",
  "Education",
  "Experience",
  "Awards",
  "Organization",
];

const StepIndicator = ({ currentStep }) => {
  return (
    <div className="flex items-center font-Outfit  mb-4">
      {steps.map((label, i) => (
        <div
          key={i}
          className="flex items-center gap-2 px-2"
        >
          <div
            className={`rounded-full w-6 h-6 flex items-center justify-center ${
              i + 1 <= currentStep ? "bg-blue-600 text-white" : "bg-gray-300"
            }`}
          >
            {i + 1}
          </div>
          <span className="text-base text-center">{label}</span>
        </div>
      ))}
    </div>
  );
};

export default StepIndicator;
